import React from 'react'
import { LanguageContext } from '../Context/LanguageContext';
import { useContext } from 'react';
import FooterInfo from '../components/FooterInfo';
import location_icon from '../assets/icons/location_icon.png';
import mail_icon from '../assets/icons/mail_icon.png';
import tel_icon from '../assets/icons/tel_icon.png';
import facebook_icon from '../assets/icons/facebook.png';


export const Footer = () => {
  const { texts ,language} = useContext(LanguageContext);


  return (
    
<footer id='contact' class="p-4 bg-gray-500  md:pr-6 md:pl-6 mt:pr-6 md:pb-4 md:py-8 w-full m-auto text-white">
    <div class="max-w-[1300px] m-auto flex flex-col items-center md:justify-center justify-start">
           <h1 className='font-semibold text-lg md:w-[800px] text-center w-full mt-5'>{texts.footer_text}</h1>
           <div className=' flex  flex-wrap md:w-[800px] w-full items-center  md:justify-center justify-start  mt-12 mb-10'>
              <FooterInfo text={texts.location} icon={location_icon} language={language}/>
              <FooterInfo text={'dezhwarkawa@gmail.com'} icon={mail_icon} language={language}/>
              <FooterInfo text={'07701523385 - 07701561674'} icon={tel_icon} language={language}/>
              {/* <div className={`flex  items-center  justify-items-center m-4 `}>
               <img className={`${language=='en'?'mr-4':'ml-4'} `} src={facebook_icon} alt="icon" />
              <a target="_blank" href='https://www.facebook.com/qalatalfarouq'  className='text-white text-lg font-semibold '>facebook.com/qalatalfarouq</a>
    </div> */}
           </div>
    </div>

    
    <hr class=" border-yellow-400 sm:mx-auto max-w-[1300px]  mt-5 mb-5" />

      <div class="max-w-[1300px] m-auto flex  items-center justify-center">
         <span class="block   sm:text-center text-md font-serif" dir='ltr'>
           ©{(new Date().getFullYear())} <a target="_blank" href="https://qalatalfarouq.com" class="hover:underline">Dizhwar Kawa Kaka Bra Company™</a>. All Rights Reserved.
         </span>
      </div>

</footer>

  )
}
